<template>
  <div style="background: #fff; height: 100%">
    <van-nav-bar
      title="请登录"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="ht60"></div>
    <div class="logoName">眉山市东坡区民政局</div>
    <div class="logoName2">救助对象年审系统</div>
    <div class="ht15"></div>
        <div class="ht15"></div>
    <div class="loginZone" v-if="utype === 3">
      <div>
        <van-cell>
          <template #title>
            <div class="fscc cellTitle">
              <div class="cellTileI fsac">
                <van-icon name="manager-o"  color="#1678ff" size="5.5vw"/>
              </div>
              <div class="login-title">姓名</div>
            </div>
          </template>
        </van-cell>
        <van-field v-model="name"  class="mt-10" placeholder="请输入您的姓名" size="large" clearable>
        </van-field>
        <van-divider :style="{ color: '#fff', borderColor: '#fff', padding: '0 16px' }"></van-divider>
      </div>

      <div class="mt10">
        <div>
          <van-cell>
            <template #title>
              <div class="fscc cellTitle">
                <div class="cellTileI fsac">
                  <van-icon name="idcard"  color="#1678ff" size="5.5vw"/>
                </div>
                <div class="login-title">身份证号码</div>
              </div>
            </template>
          </van-cell>
          <van-field class="mt-10" v-model="cardNo"  type="digit" placeholder="请输入您的身份证号">
          </van-field>
          <van-divider :style="{ color: '#fff', borderColor: '#fff', padding: '0 16px' }"></van-divider>
          <!-- <div style="border-bottom: 1px solid #fdfdfd"></div> -->
        </div>
      </div>
      <div class="ht60"></div>
      <div class="mt10 fsac" style="width: 100%">
        <van-button type="info" size="normal" color="#1678ff" @click="login" round>
          <div class="loginBtn" style="font-weight: bold">登录</div>
        </van-button>
      </div>
    </div>
    <div class="loginZone" v-if="utype === 2">
      <div>
        <van-cell>
          <template #title>
            <div class="fscc cellTitle">
              <div class="cellTileI fsac">
                <van-icon name="manager-o"  color="#1678ff" size="5.5vw"/>
              </div>
              <div class="login-title">用户名</div>
            </div>
          </template>
        </van-cell>
        <van-field v-model="phone"  class="mt-10" placeholder="请输入您的用户名" size="large" clearable>
        </van-field>
        <van-divider :style="{ color: '#fff', borderColor: '#fff', padding: '0 16px' }"></van-divider>
      </div>

      <div class="mt10">
        <div>
          <van-cell>
            <template #title>
              <div class="fscc cellTitle">
                <div class="cellTileI fsac">
                  <van-icon name="idcard"  color="#1678ff" size="5.5vw"/>
                </div>
                <div class="login-title">密码</div>
              </div>
            </template>
          </van-cell>
          <van-field class="mt-10" v-model="password"  type="password" placeholder="请输入密码">
          </van-field>
          <van-divider :style="{ color: '#fff', borderColor: '#fff', padding: '0 16px' }"></van-divider>
          <!-- <div style="border-bottom: 1px solid #fdfdfd"></div> -->
        </div>
      </div>
      <div class="ht60"></div>
      <div class="mt10 fsac" style="width: 100%">
        <van-button type="info" size="normal" color="#1678ff" @click="login" round>
          <div class="loginBtn" style="font-weight: bold">登录</div>
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading, Field, Button, Toast, Cell, Icon, NumberKeyboard, Divider, NavBar } from 'vant';
// import axios from 'axios'
export default {
  mounted () {
    // this.checkComp()
    this.checkUtype()
    this.checkUa()
  },
  components: {
    [Loading.name]: Loading,
    [Field.name]: Field,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [NumberKeyboard.name]: NumberKeyboard,
    [Divider.name]: Divider,
    [NavBar.name]: NavBar
  },
  data() {
    return {
      name: '',
      cardNo: '',
      worker: '',
      userType: '3',
      phone: '',
      utype: '3',
      password: '',
      checkList: [],
      isAndroid: false,
      isiOS: false,
      show: false
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    checkComp () {
      let types = [
        'video/webm',
        'video/webm;codecs=vp8',
        'video/webm;codecs=vp9',
        'video/webm;codecs=daala',
        'video/webm;codecs=h264',
        'video/3gpp',
        'video/3gpp2',
        'video/mp4',
        'video/mpeg'
      ]
      let canIuseMediaRecorder = true
      try {
        MediaRecorder.isTypeSupported('vedio/webm')
      } catch (e) {
        canIuseMediaRecorder = false
      }
      for (let i in types) { 
        let item = types[i]
        this.checkList.push(
          {k: item,  v: MediaRecorder.isTypeSupported(item)}
        )
        // alert( 'Is ' + types[i] + ' supported? ' + (MediaRecorder.isTypeSupported(item) ? 'Maybe!' : 'Nope :(')); 
      }
      let t = this.checkList.filter(item => {
        if (item.v) {
          return item
        }
      })
      if (t.length >= 1) {
        window.localStorage.setItem('f1', t[0].k)
        // alert(t[0].k)
      }
    },
    checkUtype () {
      let {query} = this.$route
      this.utype = Number(query.utype)
    },
    checkDate (val) {
      let pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/
      if (pattern.test(val)) {
        let year = val.substring(0, 4)
        let month = val.substring(4, 6)
        let date = val.substring(6, 8)
        let date2 = new Date(year + '-' + month + '-' + date)
        if (date2 && date2.getMonth() == (parseInt(month) - 1)) {
            return true
        }
      }
      return false
    },
    checkCode (val) {
        let p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        let factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ]
        let parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ]
        let code = val.substring(17)
        if (p.test(val)) {
            let sum = 0
            for(let i=0; i<17; i++) {
              sum += val[i] * factor[i]
            }
            if (parity[sum % 11] == code.toUpperCase()) {
              return true
            }
        }
        return false
    },
    checkID (val) {
      if(this.checkCode(val)) {
        let date = val.substring(6,14)
        if(this.checkDate(date)) {
            // if(checkProv(val.substring(0,2))) {
          return true;
            
        }
      }
      return false
    },
    onInput (e) {
      this.cardNo += e
    },
    onDelete () {
      this.cardNo = ''
    },
    checkOs (u) {
      // 获取系统版本
      let os = ''
      let version = ''
      if (u.indexOf('Mac OS X') > -1) {
        // ios
        let regStr_saf = /OS [\d._]*/gi
        let verinfo = u.match(regStr_saf)
        os = 'IOS'
        version = (verinfo + '').replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.')
      } else if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        // android
        os = 'Android'
        version = u.substr(u.indexOf('Android') + 8, u.indexOf(';', u.indexOf('Android')) - u.indexOf('Android') - 8)
      } else if (u.indexOf('BB10') > -1) {
        // 黑莓bb10系统
        os = 'blackberry'
        version = u.substr(u.indexOf('BB10') + 5, u.indexOf(';', u.indexOf('BB10')) - u.indexOf('BB10') - 5)
      } else if (u.indexOf('IEMobile') > -1) {
        // windows phone
        os = 'winphone'
        version = u.substr(u.indexOf('IEMobile') + 9, u.indexOf(';', u.indexOf('IEMobile')) - u.indexOf('IEMobile') - 9)
      } else {
        let userAgent = navigator.userAgent.toLowerCase()
        os = 'Windows'
        if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
          version = '7'
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
          version = '8'
        } else if (userAgent.indexOf('windows nt 6.3') > -1) {
          version = '8.1'
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
          version = '10'
        } else {
          os = 'Unknown'
          version = 'Unknown'
        }
      }
      return {os, version}
    },
    checkUa () {
      let u = navigator.userAgent
      let v = this.checkOs(u)
      let {os, version} = v
      if (version) {
        let versionL = version.split('.')
        let sub = versionL[1] || ''
        version = sub ? `${version[0]}.${sub}` : versionL[0]
      }
      this.os = os
      this.version = version
      window.localStorage.setItem('os', os)
      window.localStorage.setItem('version', version)
      this.checkComp()
    },
    async login () {
      if (this.utype === 3) {
        this.loginUser()
      } else {
        this.loginWorker()
      }
    },
    async loginWorker () {
      if (!this.phone) {
        Toast('请输入用户名')
        return
      } 
      if (!this.password) {
        Toast('请输入密码')
        return
      }
      if (this.os === 'ios' && Number(this.version) < 14.4 ) {
        Toast.loading({
          message: `当前的IOS系统版本为${this.os},请升级为14.4及以上版本`,
          forbidClick: true,
          overlay: true,
          duration: 0
        })
        return
      }
      let {success, info, data} = await this.$api.login({
        phone: this.phone,
        password: this.password,
        terminal: 'phone',

      })
      if (success) {
        window.localStorage.setItem('token', data.token)
        this.$router.replace('/worker')
        console.log(info)
      } else {
         Toast(info)
      }
    },
    async loginUser () {
      try {
        window.localStorage.setItem('test111', '11')
      } catch (e) {
        alert('error:' + e.name + e.stack)
      }
      if (!this.name) {
        Toast('请输入姓名')
        return
      } 
      if (!this.cardNo) {
        Toast('请输入身份证号码')
        return
      }
      if (!this.checkID(this.cardNo)) {
        Toast('请输入正确的身份证号码')
        return
      }
      if (this.os === 'ios' && Number(this.version) < 14.4 ) {
        Toast.loading({
          message: `当前的IOS系统版本为${this.os},请升级为14.4及以上版本`,
          forbidClick: true,
          overlay: true,
          duration: 0
        })
        return
      }
      let {success, info, data} = await this.$api.login({
        name: this.name,
        idCard: this.cardNo,
        terminal: 'phone'
      })
      if (success) {
        window.localStorage.setItem('token', data.token)
        this.$router.replace('/my')
        console.log(info)
      } else {
         Toast(info)
      }
    }
  }
};
</script>

<style>

  .logo {
    width: 125px;
    margin-left: 125px;
  }
  .logoimg {
    width: 125px;
  }
  .logoName {
    margin: 10px 40px;
    height: 24px;
    line-height: 24px;
    color: #444;
    font-size: 20px;
    text-shadow: 0px 0px 1px #333;
    text-align: center
  }
 .logoName2 {
    margin: 5px 40px;
    height: 24px;
    line-height: 24px;
    color: #444;
    font-size: 22px;
    text-shadow: 0px 0px 1px #333;
    text-align: center
  }
  .loginZone{
    margin: 26px;
    /* padding: 25px; */
  }
  .login-title {
    font-size: 15px;
    color: #666;
    margin-left: 6px;
    font-weight: 400;
    letter-spacing: 1px;
    /* text-shadow: 0px 0px 1px #333; */
  }
  .loginBtn {
    width: 220px;
    color: azure;
  }

</style>
